<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Help</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content [paddingBottom]="true">
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-list-header>
      <ion-label>Legend</ion-label>
    </ion-list-header>
    <ion-item-divider>
      <ion-label>Owner Status</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label>Owner Occupied</ion-label>
      <ion-icon slot="start" src="/assets/svg/owner-occupied.svg"></ion-icon>
    </ion-item>
    <ion-item>
      <ion-label>Owner Absentee</ion-label>
      <ion-icon slot="start" src="/assets/svg/owner-unoccupied.svg"></ion-icon>
    </ion-item>
    @if (organizationFarmAlertsEnabled$ | async) {
      <ion-item-divider>
        <ion-label>Farm Alerts</ion-label>
      </ion-item-divider>
      <ion-item>
        <ion-label>Has Alerts</ion-label>
        <ion-icon slot="start" src="/assets/svg/alert.svg"></ion-icon>
      </ion-item>
    }
    <ion-item-divider>
      <ion-label>Lead Status</ion-label>
    </ion-item-divider>
    @for (walkingFarmAvailableLeadStatus of walkingFarmAvailableLeadStatuses; track walkingFarmAvailableLeadStatus) {
      <ion-item>
        <ion-label>{{ walkingFarmAvailableLeadStatus.label }}</ion-label>
        <ion-icon slot="start" name="ellipse" [style.color]="walkingFarmAvailableLeadStatus.color"></ion-icon>
      </ion-item>
    }
    <ion-item-divider>
      <ion-label>Ordering</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label>
        Drag & drop handle for properties
        <br />
        <ion-note color="warning" class="tw:text-sm tw:text-wrap">
          This functionality is disabled if you have any filters applied.
        </ion-note>
      </ion-label>
      <ion-icon slot="start" name="menu-outline"></ion-icon>
    </ion-item>
  </ion-list>
</red-page-content>
